import { api } from '../api';

interface UserListParams {
  role?: string;
  tenantId?: string;
  page?: number;
  limit?: number;
  search?: string;
}

export const userService = {
  list: (params?: UserListParams) => api.get('/users', { params }),
  get: (id: string) => api.get(`/users/${id}`),
  create: (data: FormData) => api.post('/users', data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  update: (id: string, data: any) => api.patch(`/users/${id}`, data),
  remove: (id: string) => api.delete(`/users/${id}`),
};